import React, { useState, useCallback } from 'react';
import { useInsuranceTypeConfiguration, useQueryWithSimpleErrorHandling, useSimpleError } from 'hooks';
import { insuranceTypeNames } from 'constants/defaultValues';
import CrossCheckFlowComponent from '../CrossCheckFlowComponent';
import { useMutation } from 'features/common/security/hooks';
import { CHECK_RCA_CROSS_CHECK_FLOW } from '../../../mutations';
import { INSURANCE_DOCUMENTS_FOR_CHECK_QUERY } from 'features/settings/queries';
import { useCrossCheckUtils } from '../utils';
import { useTranslation } from 'react-i18next';

const RcaCrossCheckFlowContainer = () => {
  const showError = useSimpleError();
  const { t } = useTranslation();
  const { updateCrossChecksSelectedStatus } = useCrossCheckUtils();
  const { rcaInsuranceTypeConfiguration } = useInsuranceTypeConfiguration(new Array(insuranceTypeNames.RCA));
  const rcaTypeCode = rcaInsuranceTypeConfiguration?.PropertyCode;
  const [checkData, setCheckData] = useState([]);
  const [crossCheckResults, setCrossCheckResults] = useState([]);

  useQueryWithSimpleErrorHandling(INSURANCE_DOCUMENTS_FOR_CHECK_QUERY, {
    variables: { insuranceTypeCode: rcaInsuranceTypeConfiguration?.PropertyCode },
    skip: !rcaTypeCode,
    onCompleted: data => {
      const documents = data.insuranceDocumentsForCheck || [];
      setCheckData(
        documents.map(x => ({
          ...x,
          selected: false
        }))
      );
    }
  });

  const [checkRCACrossCheckFlow] = useMutation(CHECK_RCA_CROSS_CHECK_FLOW, {
    onError: error => {
      showError(error);
    }
  });

  const handleSelect = useCallback(documentId => {
    setCheckData(prev => prev.map(x => (x.documentId === documentId ? { ...x, selected: !x.selected } : x)));
  }, []);

  const handleSelectAll = useCallback(() => {
    setCheckData(prev => {
      const allSelected = prev.every(x => x.selected);
      return prev.map(x => ({ ...x, selected: !allSelected }));
    });
  }, []);

  const handleCrossCheckFlow = useCallback(() => {
    const selected = checkData.filter(x => x.selected);
    checkRCACrossCheckFlow({
      variables: {
        input: {
          documentIds: selected.map(x => x.documentId)
        }
      }
    });
    setCrossCheckResults(
      selected.map(({ documentId, documentNumber, documentDate }) => ({
        documentId,
        documentNumber,
        documentDate
      }))
    );
    var crossChecksSelected = selected.map(({ documentId }) => ({ documentId, loading: true }));
    updateCrossChecksSelectedStatus(crossChecksSelected);
  }, [checkData, checkRCACrossCheckFlow, updateCrossChecksSelectedStatus]);

  return (
    <CrossCheckFlowComponent
      crossCheckResults={crossCheckResults}
      checkData={checkData}
      onSelect={handleSelect}
      onSelectAll={handleSelectAll}
      onCheckCrossFlow={handleCrossCheckFlow}
      title={t('Settings.InsuranceIntegrationChecks.RcaCheck.CrossCheck')}
      insuranceTypeCode={rcaTypeCode}
    />
  );
};

RcaCrossCheckFlowContainer.propTypes = {};

export default RcaCrossCheckFlowContainer;
